import Layout from '@/layout/index.vue'

const cmpRoutes = [
    {
        path: '/info',
        name: 'Info',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '简介',
            icon: 'OfficeBuilding'
        },
        children: [
            {
                path: '',
                name: 'Info',
                component: () => import('@/modules/info/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '总览',
                    icon: 'OfficeBuilding'
                }
            },
        ]
    },
    {
        path: '/',
        name: 'Dashboard',
        component: Layout,
        redirect: '/dashboard',
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '全局监控',
            icon: 'Monitor'
        },
        children: [
            {
                path: 'dashboard',
                name: 'CompanyMonitor',
                component: () => import('@/modules/dashboard/company.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '总览',
                    icon: 'Monitor'
                }
            },
            {
                path: 'dashboard/:projId',
                name: 'ProjectMonitor',
                component: () => import('@/modules/dashboard/project.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '项目监控',
                    icon: 'Monitor'
                }
            }
        ]
    },
    {
        path: '/company',
        name: 'Company',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '平台管理',
            icon: 'OfficeBuilding'
        },
        children: [
            {
                path: 'user',
                name: 'UserList',
                component: () => import('@/modules/user/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '用户管理',
                    icon: 'User'
                },
            },
            {
                path: 'project',
                name: 'ProejctList',
                component: () => import('@/modules/project/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '项目管理',
                    icon: 'Box'
                },
            },
            {
                path: 'edit',
                name: 'EditCompany',
                component: () => import('@/modules/company/edit/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源管理',
                    icon: 'Film'
                },
            },
            {
                path: 'resource',
                name: 'Assets',
                component: () => import('@/modules/asset/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '资源列表',
                    icon: 'Picture'
                },
            },
            {
                path: 'detail/:projId',
                name: 'ProejctDetail',
                component: () => import('@/modules/project/detail.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    hidden: true,
                    title: '资源配置'
                },
            },
        ]
    },
    {
        path: '/device',
        name: 'Device',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '监测点位&硬件设备',
            icon: 'Cpu'
        },
        children: [
            {
                path: 'point',
                name: 'PointList',
                component: () => import('@/modules/point/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '监测列表',
                    icon: 'Place'
                },
            },
            {
                path: 'terminal',
                name: 'TerminalList',
                component: () => import('@/modules/device/terminal.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '采集设备',
                    icon: 'Cellphone'
                },
            },
            {
                path: 'sensor',
                name: 'SensorList',
                component: () => import('@/modules/device/sensor.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '传感器',
                    icon: 'Odometer'
                },
            },
            {
                path: 'record',
                name: 'RecordList',
                component: () => import('@/modules/record/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '维保记录',
                    icon: 'DataAnalysis',
                },
            },
            {
                path: 'warning',
                name: 'WarningList',
                component: () => import('@/modules/warning/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '历史预警',
                    icon: 'DataAnalysis',
                },
            },
            {
                path: 'data',
                name: 'DataList',
                component: () => import('@/modules/data/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '硬件数据',
                    icon: 'DataAnalysis',
                },
            },
            // {
            //     path: 'other',
            //     name: 'Other',
            //     component: () => import('@/modules/device/other.vue'),
            //     meta: {
            //         requiresAuth: true, // 访问该路由需要身份验证
            //         title: '内部设备',
            //         icon: 'IceCreamSquare',
            //     },
            // }
        ]
    },
    // {
    //     path: '/point',
    //     name: 'Point',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '监测点位',
    //         icon: 'Place'
    //     },
    //     children: [
    //         {
    //             path: '',
    //             name: 'PointList',
    //             component: () => import('@/modules/point/index.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: 'File列表',
    //                 icon: 'FolderOpened'
    //             },
    //         }
    //     ]
    // },
    // {
    //     path: '/data',
    //     name: 'Data',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '硬件数据',
    //         icon: 'DataAnalysis',
    //     },
    //     children: [
    //         {
    //             path: '',
    //             name: 'DataList',
    //             component: () => import('@/modules/data/index.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: '列表'
    //             },
    //         }]
    // },
    // {
    //     path: '/user',
    //     name: 'User',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '平台用户',
    //         icon: 'User'
    //     },
    //     children: [
    // {
    //     path: '',
    //     name: 'UserList',
    //     component: () => import('@/modules/user/index.vue'),
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '列表'
    //     },
    // }
    // ]
    // },
    {
        path: '/honor',
        name: 'Honor',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '资质荣誉',
            icon: 'Guide'
        },
        children: [
            {
                path: '',
                name: 'HonorList',
                component: () => import('@/modules/honor/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源列表',
                    icon: 'Picture'
                },
            }
        ]
    },
    {
        path: '/achv',
        name: 'Achvs',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '项目业绩',
            icon: 'TrendCharts'
        },
        children: [
            {
                path: '',
                name: 'AchvsList',
                component: () => import('@/modules/achv/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源列表',
                    icon: 'Picture'
                },
            }
        ]
    },
    {
        path: '/partner',
        name: 'Partner',
        component: Layout,
        meta: {
            requiresAuth: true, // 访问该路由需要身份验证
            title: '合作单位',
            icon: 'Connection'
        },
        children: [
            {
                path: '',
                name: 'PartnerList',
                component: () => import('@/modules/partner/index.vue'),
                meta: {
                    requiresAuth: true, // 访问该路由需要身份验证
                    title: '资源列表',
                    icon: 'Picture'
                },
            }
        ]
    },
    // {
    //     path: '/resource',
    //     name: 'Resource',
    //     component: Layout,
    //     meta: {
    //         requiresAuth: true, // 访问该路由需要身份验证
    //         title: '文件资源',
    //         icon: 'Files'
    //     },
    //     children: [
    //         {
    //             path: '',
    //             name: 'Assets',
    //             component: () => import('@/modules/asset/index.vue'),
    //             meta: {
    //                 requiresAuth: true, // 访问该路由需要身份验证
    //                 title: '资源列表',
    //                 icon: 'Picture'
    //             },
    //         }
    //     ]
    // },
]

export default cmpRoutes;